import { render, staticRenderFns } from "./MainRequestForm.vue?vue&type=template&id=2974dbb1&scoped=true&"
import script from "./MainRequestForm.vue?vue&type=script&lang=js&"
export * from "./MainRequestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2974dbb1",
  null
  
)

export default component.exports